if (!window.__cartDrawerAddonsBound) {
  window.__cartDrawerAddonsBound = true;

  function cartAddEndpoint() {
    const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js(\?|$)/.test(base) ? base : `${base}.js`;
  }

  function parseCartJson(response) {
    return response.text().then((text) => {
      try {
        return JSON.parse(text);
      } catch (error) {
        throw new Error('Could not add to cart. Please refresh and try again.');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-drawer-addon-add]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    const variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const sections =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('sections', [...new Set(sections)]);
    formData.append('sections_url', window.location.pathname || '/');

    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(cartAddEndpoint(), config)
      .then(parseCartJson)
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data, true);
          }
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-addons', cartData: data });
        }
      })
      .catch((error) => {
        const errorBox = document.getElementById('CartDrawer-CartErrors');
        const message = error.message || (window.cartStrings && window.cartStrings.error) || 'Could not add to cart';
        if (errorBox) errorBox.textContent = message;
        else console.error(error);
      })
      .finally(() => {
        if (button.isConnected) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      });
  });
}
